import { prizeContract } from '@daymade/api-contracts';
import { ClientInferResponseBody } from '@ts-rest/core';
import Link from 'next/link';
import router from 'next/router';
import PrizeFilterOptions from 'prizes/weekly-draw/PrizeFilterOptions';
import { ASSET_PREFIX } from 'utils/constants';
import ImageWithFallback from './ImageWithFallback';
import PrizeCardWithTitleBelow from './prizes/PrizeCardWithTitleBelow';
import PrizeList from './prizes/PrizeList';

type TPrizes = ClientInferResponseBody<
  typeof prizeContract.public.getAllAvailablePrizes,
  200
>;

type TPrize = TPrizes[0];

interface IPrizesPreview {
  prizes: TPrizes;
}

export const PrizesPreview = ({ prizes }: IPrizesPreview) => {
  return (
    <div className="w-full relative">
      <div className="w-full flex flex-wrap gap-4 mb-5 px-5 md:justify-center md:gap-10">
        {PrizeFilterOptions.map((filter) => {
          return (
            <Link
              key={filter.id ?? 'NA'}
              href={filter.href}
              passHref
            >
              <div>
                <div className="imageContainer">
                  {
                    <ImageWithFallback
                      src={filter.icon}
                      fallbackSrc={filter.icon}
                      width="90"
                      height="90"
                    />
                  }
                </div>

                <div
                  style={{
                    fontWeight: '600',
                    textShadow: 'none',
                    textAlign: 'center',
                  }}
                >
                  {filter.name.replace('Trips & Stays', 'Trips')}
                </div>
              </div>
            </Link>
          );
        })}
      </div>

      <PrizeList
        pageSize={6}
        style={undefined}
      >
        {prizes.slice(0, 6).map((prize: TPrize, key: number) => (
          <PrizeCardWithTitleBelow
            titleStyle={{
              fontFamily: "'Montserrat', sans-serif",
              fontWeight: 700,
            }}
            subheadingStyle={{
              fontFamily: "'Montserrat', sans-serif",
              fontWeight: 400,
            }}
            key={key}
            prize={prize}
            withFavouriteButton={true}
            onClick={() => router.push(`/prizes/details/${prize.slug}`)}
            showLockedPrizeBannerIfApplicable={true}
            style={undefined}
            displayGroup={undefined}
            onChangePrizeDisplayOrdering={undefined}
            customImageOpacity={undefined}
          />
        ))}
      </PrizeList>

      <div
        style={{
          background:
            'linear-gradient(rgba(255, 255, 255, 0), rgb(255, 255, 255))',
          height: '250px',
          marginTop: '-240px',
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'end',
        }}
      >
        <div className="flex flex-col justify-center items-center gap-2">
          <img
            style={{
              cursor: 'pointer',
              width: '28px',
              height: '28px',
              transition: '0.5s ease-in-out',
              transform: 'rotate(0deg)',
            }}
            src={`${ASSET_PREFIX}/images/plus-circle.svg`}
            onClick={() => router.push('/prizes')}
          />
          <p>SEE MORE</p>
        </div>
      </div>
    </div>
  );
};
